module.exports = __webpack_public_path__ + "img/center_gray.7474fc26.svg";